import { render } from "./XTitle.vue?vue&type=template&id=72f7ba0c&scoped=true"
import script from "./XTitle.vue?vue&type=script&lang=js"
export * from "./XTitle.vue?vue&type=script&lang=js"

import "./XTitle.vue?vue&type=style&index=0&id=72f7ba0c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f7ba0c"]])

export default __exports__